const ConfimedTileBlock = ({ count }: { count: number }) => (
  <div className="w-full bg-[#FFF4E8] px-[3px] py-[4px] rounded text-[#FF7C1D]">승인 {count}</div>
);

export default ConfimedTileBlock;
